import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  circle: {
    marginRight: 19,
    marginLeft: 3,
    marginTop: 10,
    marginBottom: 19,
  },
  title: {
    marginTop: 10,
    marginBottom: 8,
    width: 173,
    height: 13,
  },
  subtitle: {
    marginBottom: 16,
    width: 69,
    height: 13,
  },
  mainContent: {
    marginTop: 23,
    marginLeft: 1,
    marginBottom: 17,
    width: 131,
    height: 12,
  },
  price: {
    marginTop: 23,
    marginBottom: 18,
    width: 40,
    height: 12,
  },
  showMore: {
    marginTop: 18,
    marginBottom: 2,
    alignSelf: 'center',
    width: 131,
    height: 12,
  },
  line: {
    width: '100%',
    height: 1,
  },
});
